import _ from 'lodash';
import { mergeUrl } from 'utils/url';

import { RequestState, } from 'constants/constants';
const { REQUEST, SUCCESS, FAIL, NOT_AUTHORIZED } = RequestState;

const DEFAULT_HOST = window.hs_config.hosts.API;

function _fetch(options) {
  let { url, params, method, dispatch, 
    action, body, headers, host = DEFAULT_HOST, mode, data } = options;

  url = restUrl(url, params, host);
  let init = fetchInit(method, body, headers, mode);

  // Disaptch Request
  if(dispatch && action) {
      dispatch(request(action, url, params, body, data));  
  }

  // Do Fetch
  return fetch(url, init)
    .then(response => response.json()
        .then(json => ({ code: response.status, json })) )
    .then(parsedResponse => {
      let { code, json } = parsedResponse;

      // Handle errors for all the differents kinds of responses :/
      if(
        !json ||
        (code && code != 200) ||
        (json.code && json.code != 200) ||
        json.status === "ERROR") {
          let err = {
            message: json.message || 'Uknown Error',
            code: code || json.code || 'Uknown Code',
          }
          if(dispatch && action) {
            dispatch(error(action, err, url, params, data));
          }
          if(code && (code === 401 || code === 403)) {
            dispatch({ type: 'LOGOUT_USER', });
            window.location = '/';
          }
          return Promise.reject({ ...err, action });
      } 

      if(dispatch && action) {
        dispatch(receive(action, json, url, params, data));
      }
      json.headers = headers;
      return Promise.resolve(json);
    })
    .catch(err => { // network error
      if(typeof err === 'string') { 
        console.log("URL is unreachable: ", url, err);
        return Promise.reject({ message: err });
      } 
      console.log(err);
      return Promise.reject(err);
    });
}
export const get = (options) => _fetch(_.defaults({ method: 'get' }, options));
export const post = (options) =>_fetch(_.defaults({ method: 'post' }, options));
export const put = (options) =>_fetch(_.defaults({ method: 'put' }, options));
export const del = (options) =>_fetch(_.defaults({ method: 'delete' }, options));

export function request(action, url, params, body, data = null) {
    return {
      type: action,
      url,
      params,
      body,
      result: REQUEST,
      fetchAt: Date.now(),
      ...data,
    };
}

export function receive(action, json, url, params, data = null) {
  return {
    type: action,
    json,
    url,
    params,
    result: SUCCESS,
    receivedAt: Date.now(),
    ...data
  }
}

export function error(action, error, url, params, data) {
  return {
    type: action,
    ...error,
    url,
    params,
    result: FAIL,
    receivedAt: Date.now(),
    ...data,
  }
}

export function fetchInit(method = 'get', body, headers = {}, mode = 'cors') {
  if(body) {
    headers = _.assign(headers, {
      'Content-Type': 'application/json',
    });
  }
  let init = {
    method,
    headers,
    mode,
  };
  init = body ? _.assign(init, { body: JSON.stringify(body) }) : init;
  return init;
}

export function restUrl(url, params, host) {
  if(url.indexOf("http") !== -1) {
    return mergeUrl(url, params, urlMap);
  }
  return mergeUrl(host + url, params);
}
